var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[(_vm.userIsAParent)?_c('div',{staticClass:"h-100 bg-plain"},[_c('parent-main')],1):_c('div',{staticClass:"h-100 bg-plain"},[_c('child-main')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }